import {
  AuditLogRepresentation,
  OrganizationRepresentation,
} from "../infrastructure/api/api";
import { getJSON } from "../infrastructure/api/digipost-fetch";
import { findUriIfExists } from "../infrastructure/entrypoint/link";

export const AUDIT_LOG_PAGE_SIZE = 10;

export interface AuditLogApi {
  getPage: (page: number) => Promise<AuditLogRepresentation[]>;
}

export function auditLogApi(
  organization: OrganizationRepresentation,
): AuditLogApi {
  const auditLogUrl = findUriIfExists("auditlog", organization._links);

  const getPage = (page: number): Promise<AuditLogRepresentation[]> => {
    if (!auditLogUrl) {
      return Promise.resolve([]);
    }

    const url = new URL(auditLogUrl);
    url.searchParams.set("page", String(page));

    return getJSON<AuditLogRepresentation[]>(url.toString());
  };

  return { getPage };
}
